import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Navbar from "../../../components/layout/Navbar/Navbar";
import Sidebar from "../../../components/layout/Sidebar/Sidebar";
import Header from "../../../components/layout/header/Header";
import ConfirmadaDetalheContent from "../../../components/Confirmadas/ConfirmadaDetalheContent";
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";
import concessionWhite from "../../../assets/concessionWhite.png";

const Page = styled.div`display: flex; flex-direction: column; height: 100vh; background: #fff;`;
const Body = styled.div`display: flex; flex: 1; margin-top: 60px;`;
const Main = styled.main`flex: 1; margin-left: 300px; overflow-y: auto; height: calc(100vh - 60px);`;

const ConfirmadaDetalhe = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    apiService.getCurrentUser().then((userData) => {
      if (Number(userData.cargoId) !== 4) {
        navigate("/Confirmadas", { replace: true });
        return;
      }
      setUser(userData);
      setSidebarItems(getCargoIdSidebar(userData.cargoId) || []);
    }).catch((error) => console.error("Erro ao buscar usuário:", error));
  }, [navigate]);

  return (
    <Page>
      <Navbar onLogout={apiService.logout} showHome showNotifications showProfile showLogout user={user} />
      <Body>
        <Sidebar items={sidebarItems} />
        <Main>
          <Header prefixText="CONCESSÕES / CONFIRMADAS" icon={concessionWhite} title="Vaga confirmada" />
          {user && <ConfirmadaDetalheContent />}
        </Main>
      </Body>
    </Page>
  );
};

export default ConfirmadaDetalhe;
